import { Button, Drawer, Hairline, Input, Label, Radio } from "@components";
import styles from "@styles/containers/oraculo/oracle-drawer.module.scss";
import { useState } from "react";
import { Titles } from "../../variables/Titles";

export const CouponCodeForm = ({
  node,
  visible,
  onSave,
  onRemove,
  onClose,
}) => {
  const [operand, setOperand] = useState(node.operand || "eq");
  const [code, setCode] = useState(node?.value?.split("-")?.[0] || "");
  const [pin, setPin] = useState(node?.value?.split("-")?.[1] || "");

  const getFreshNode = () => {
    return { ...node, operand, value: `${code}-${pin}` };
  };

  const validate = () => {
    if (!operand || !code || !pin) {
      return false;
    }
    return true;
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CouponCode}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <div className={styles.scrollContainer}>
        <div className={styles.card}>
          <Label>Defina o uso desta variável:</Label>
          <Hairline solid className="mt-5 mb-20" />
          <Radio
            family="variableType"
            className="mb-10"
            value="eq"
            checked={operand}
            onChange={() => setOperand("eq")}
          >
            Igual a
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="neq"
            checked={operand}
            onChange={() => setOperand("neq")}
          >
            Diferente de
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="like"
            checked={operand}
            onChange={() => setOperand("like")}
          >
            Contém
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="starts"
            checked={operand}
            onChange={() => setOperand("starts")}
          >
            Inicia com
          </Radio>
          <Radio
            family="variableType"
            value="ends"
            checked={operand}
            onChange={() => setOperand("ends")}
          >
            Termina com
          </Radio>
        </div>

        <div className={styles.card}>
          <Label>Determine o valor de comparação:</Label>
          <Hairline solid className="mt-10 mb-20" />
          <div class="d-flex">
            <Input
              placeholder="Código"
              value={code}
              onChange={(text) =>
                setCode((text.target.value || "").toLocaleUpperCase())
              }
              className="w-100 mb-0 mr-10"
            />
            <Input
              placeholder="Pin"
              maxlength={3}
              value={pin}
              onChange={(text) =>
                setPin((text.target.value || "").toLocaleUpperCase())
              }
              className="mb-0"
            />
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          className="w-100"
          onClick={() => onSave(getFreshNode())}
          disabled={!validate()}
          design="primary"
        >
          Aplicar
        </Button>
        <Button
          design="underline"
          className="mt-20 mb-10"
          onClick={() => onRemove(getFreshNode())}
        >
          Remover comparação
        </Button>
      </div>
    </Drawer>
  );
};
